export default "__VITE_ASSET__CXfx99vd__"